import React, { Component } from 'react';

class EssCard extends Component {
    static defaultProps = {
        title: null
    };

    render() {
        return (
            <div className="rating-card ess-card-2">
                {this.props.title && <div className="rating-header">
                    <span className="rating-header-body">
                        <span></span>
                        <span>
                            <span className='underlined-title-wrapper'>
                                <span className='underlined-title'>{this.props.title}</span>
                            </span>
                        </span>
                        <span>
                        </span>
                    </span>
                </div>}
                <div className="rating-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default EssCard;